import {
  SET_COLUMN_ORDER,
  SET_COLUMN_WIDTHS,
  SET_CURRENT_PAGE,
  SET_FILTERS,
  SET_HIDDEN_COLS,
  SET_PAGE_SIZE,
  SET_SORTING,
} from "../actions/dataGrid";

const STORAGE_PREFIX = 'dataGrid_';

const initialState = {
  dataGridByName: loadGridStates()
};

function saveGridState(name, data) {
  if (window && window.localStorage) {
    window.localStorage.setItem(`${STORAGE_PREFIX}${name}`, JSON.stringify(data));
  }
}

export function loadGridStates() {
  if (window && window.localStorage) {
    return Object.keys(localStorage)
      .filter(item => localStorage.hasOwnProperty(item) && item.indexOf(STORAGE_PREFIX) === 0)
      .reduce((prev, next) => ({
        ...prev,
        [next.substr(STORAGE_PREFIX.length)]: JSON.parse(localStorage[next])
      }), {});
  }
  return {};
}

export default function dataGrid(state = initialState, action = {}) {
  let gridState = {};

  switch (action.type) {
    case SET_COLUMN_ORDER:
      gridState = {
        ...state.dataGridByName[action.name],
        columnOrder: action.columnOrder
      };
      saveGridState(action.name, gridState);
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_COLUMN_WIDTHS:
      gridState = {
        ...state.dataGridByName[action.name],
        columnWidths: action.columnWidths
      };
      saveGridState(action.name, gridState);
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_CURRENT_PAGE:
      gridState = {
        ...state.dataGridByName[action.name],
        currentPage: action.currentPage
      };
      if (action.saveState) {
        saveGridState(action.name, gridState);
      }
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_PAGE_SIZE:
      gridState = {
        ...state.dataGridByName[action.name],
        pageSize: action.pageSize,
        currentPage: 0
      };
      if (action.saveState) {
        saveGridState(action.name, gridState);
      }
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_FILTERS:
      gridState = {
        ...state.dataGridByName[action.name],
        filters: action.filters,
        filtersChanged: true,
        currentPage: 0
      };
      if (action.saveState) {
        saveGridState(action.name, gridState);
      }
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_SORTING:
      gridState = {
        ...state.dataGridByName[action.name],
        sorting: action.sorting,
        currentPage: 0
      };
      if (action.saveState) {
        saveGridState(action.name, gridState);
      }
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };

    case SET_HIDDEN_COLS:
      gridState = {
        ...state.dataGridByName[action.name],
        hiddenCols: action.hiddenCols
      }
      saveGridState(action.name, gridState);
      return {
        ...state,
        dataGridByName: {
          ...state.dataGridByName,
          [action.name]: gridState
        }
      };


    default:
      return state;
  }
}
